import { useI18n } from "src/utils/lni18n";
import HtmlTextEditor from 'src/components/TextEditor/HtmlTextEditor';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { EditTestDataDTO, FiletestDataDto } from '../DomainModels';
import { debouncer } from "src/utils/debouncer";
import { Controller, useForm, ValidateResult } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import {  testDataAtom } from "../TestService";
import { useAtom } from "jotai";
import { getFileSizeString } from "src/utils/FileSizeUtils";

const FileTest = (props: { readOnly: boolean, data: EditTestDataDTO<FiletestDataDto>, onChange: (d: FiletestDataDto) => void }) => {

    const { data, onChange, readOnly } = props;
    const { languageService: t } = useI18n();
    const [showFiletypes, setshowFiletypes] = useState(data.TestData.UseStandardFileTypes);
    const [generalTestData] = useAtom(testDataAtom);
    const saveDebouncer = useRef<debouncer | null>(null);

    const [testData] = useAtom(testDataAtom);


    const { control, trigger, watch, register, formState: { errors }, getValues } = useForm({
        defaultValues: data.TestData,
        mode: "onChange"
    });




    React.useEffect(() => {
        const subscription = watch((value: any) => {
            trigger();
            setshowFiletypes(value.UseStandardFileTypes || false);
            saveDebouncer.current?.debounce();
        })
        return () => subscription.unsubscribe();
    }, [watch])

    const save = useCallback(() => {
        const values = getValues();
        if (values.Question.length > 0
            && (values.UseStandardFileTypes
                || !values.UseStandardFileTypes && values.CustomFileTypes.length > 0)) {
            onChange(values);
        }
    }, [getValues, onChange])

    useEffect(() => {
        const debounceReg = saveDebouncer.current = new debouncer(save, 500);
        return () => debounceReg.flush();
    }, [save])

    if (!data) return null;

    return <div className="mt-5">
        <div className='mb-2'>
            <strong>{t.getText("question")} </strong>


        </div>

        <Controller
            control={control}
            name="Question"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
                <HtmlTextEditor readOnly={readOnly} value={value} onChange={onChange} initialValue={data.TestData.Question} name="Question"  ></HtmlTextEditor>
            )}
        />
        <ErrorMessage errors={errors} name="Question" render={({ message }) => <span className="ml-1 text-danger small font-weight-bold">{t.getText('required_field')}</span>} />

        <div className="mt-4 ">
            <strong>{`${t.getText("max.filesize")}:`} </strong> {`${ getFileSizeString( testData.maxFileSize * 1024)}`}
        </div>

        <div className="mt-4 ">
            <div className='mb-2 font-weight-bold'>
                {t.getText("allowed.file.types")}
            </div>
            <div className="d-flex flex-wrap align-items-center">
                <div className="mr-5">
                    <label>
                        <input disabled={readOnly} className="mr-3" type="checkbox" {...register("UseStandardFileTypes")} />{t.getText("filetestadmin.filetypes.use.default")}
                    </label>
                </div>

                <div className="d-flex align-items-center">
                    <div className="white-space-nowrap mr-2">{t.getText("filetestadmin.filetypes.custom")}</div>
                    <input disabled={readOnly} className="form-control" type="text" {...register("CustomFileTypes",
                        {
                            validate: {
                                mustbe:
                                    (types, { UseStandardFileTypes }): ValidateResult => {
                                        if (!UseStandardFileTypes && types.length === 0)
                                            return t.getText("filetestadmin.mustdefinefiletypes")
                                        else return true;
                                    }
                            }
                        }

                    )} />

                </div>


            </div>
            <ErrorMessage errors={errors} name="CustomFileTypes" render={({ message }) => <span className="ml-1 text-danger small font-weight-bold">{message}</span>} />

            {showFiletypes && <div className="row"><div className="col-lg-6 col-xs-12 "><div className="mt-3 alert alert-grey"><strong>{t.getText("default")}<br /></strong>{generalTestData.fileTypes}</div></div></div>}
        </div>


    </div>

}

export default FileTest;

